import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { c as componentOnReady } from './helpers.js';

var attachComponent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(delegate, container, component, cssClasses, componentProps, inline) {
    var el;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!delegate) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", delegate.attachViewToDom(container, component, componentProps, cssClasses));

          case 2:
            if (!(!inline && typeof component !== 'string' && !(component instanceof HTMLElement))) {
              _context.next = 4;
              break;
            }

            throw new Error('framework delegate is missing');

          case 4:
            el = typeof component === 'string' ? container.ownerDocument && container.ownerDocument.createElement(component) : component;

            if (cssClasses) {
              cssClasses.forEach(function (c) {
                return el.classList.add(c);
              });
            }

            if (componentProps) {
              Object.assign(el, componentProps);
            }

            container.appendChild(el);
            _context.next = 10;
            return new Promise(function (resolve) {
              return componentOnReady(el, resolve);
            });

          case 10:
            return _context.abrupt("return", el);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function attachComponent(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

var detachComponent = function detachComponent(delegate, element) {
  if (element) {
    if (delegate) {
      var container = element.parentElement;
      return delegate.removeViewFromDom(container, element);
    }

    element.remove();
  }

  return Promise.resolve();
};

var CoreDelegate = function CoreDelegate() {
  var BaseComponent;
  var Reference;

  var attachViewToDom = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(parentElement, userComponent) {
      var userComponentProps,
          cssClasses,
          el,
          app,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              userComponentProps = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              cssClasses = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : [];
              BaseComponent = parentElement;
              /**
               * If passing in a component via the `component` props
               * we need to append it inside of our overlay component.
               */

              if (!userComponent) {
                _context2.next = 10;
                break;
              }

              /**
               * If passing in the tag name, create
               * the element otherwise just get a reference
               * to the component.
               */
              el = typeof userComponent === 'string' ? BaseComponent.ownerDocument && BaseComponent.ownerDocument.createElement(userComponent) : userComponent;
              /**
               * Add any css classes passed in
               * via the cssClasses prop on the overlay.
               */

              cssClasses.forEach(function (c) {
                return el.classList.add(c);
              });
              /**
               * Add any props passed in
               * via the componentProps prop on the overlay.
               */

              Object.assign(el, userComponentProps);
              /**
               * Finally, append the component
               * inside of the overlay component.
               */

              BaseComponent.appendChild(el);
              _context2.next = 10;
              return new Promise(function (resolve) {
                return componentOnReady(el, resolve);
              });

            case 10:
              /**
               * Get the root of the app and
               * add the overlay there.
               */
              app = document.querySelector('ion-app') || document.body;
              /**
               * Create a placeholder comment so that
               * we can return this component to where
               * it was previously.
               */

              Reference = document.createComment('ionic teleport');
              BaseComponent.parentNode.insertBefore(Reference, BaseComponent);
              app.appendChild(BaseComponent);
              return _context2.abrupt("return", BaseComponent);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function attachViewToDom(_x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }();

  var removeViewFromDom = function removeViewFromDom() {
    /**
     * Return component to where it was previously in the DOM.
     */
    if (BaseComponent && Reference) {
      Reference.parentNode.insertBefore(BaseComponent, Reference);
      Reference.remove();
    }

    return Promise.resolve();
  };

  return {
    attachViewToDom: attachViewToDom,
    removeViewFromDom: removeViewFromDom
  };
};

export { CoreDelegate as C, attachComponent as a, detachComponent as d };